export const SET_ONLY_SELECTED_CATEGORIES = 'SET_ONLY_SELECTED_CATEGORIES';

export const setOnlySelectedCategories = (onlySelectedCategories: boolean) => ({
  type: SET_ONLY_SELECTED_CATEGORIES,
  data: onlySelectedCategories,
});
